import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import "./datatables.scss";
import "flatpickr/dist/themes/material_red.css"
import Flatpickr from "react-flatpickr"
// datatable related plugins
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
const { ExportCSVButton } = CSVExport;
import Timezone from "./timezone";

// const MyExportCSV = (props) => {
//   const handleClick = () => {
//     const currentDate = new Date().toISOString().split('T')[0];
//     const exportFileName = `${props.filename || 'export'}_${currentDate}.csv`;
//     {
//       fileName: exportFileName, // Custom filename
//       separator: ',', // Default separator
//       noAutoBOM: false, // Example: Add BOM to the file
//     }  
//     props.onExport();
//   };
//   return <button className="btn" onClick={handleClick}>Export to CSV</button>
// };

// eslint-disable-next-line react/prop-types
const Datatables = ({ 
  showTableOnly=false,
  isCheckbox=false,
  filename= '',
  isSearch = false,
  placeholder = 'Search',
  rowsLength = 0,
  rows,
  handleAddButton,
  title,
  columns,
  loading,
  selectField,
  defaultSorted,
  keyField,
  btnTitle = 'Add',
  isAdd = true,
  isTableHead = true,
  isDisabled = false,
  fas = false,
  defaultDates,
  daterange,
  is_remote=true,
  ssr = ()=>{} }
) => {

  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(''); // State for the search input
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm); // State for the debounced input

  useEffect(() => {
      // if(searchTerm != ''){
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 1000);
  
        return () => {
            clearTimeout(handler);
        };
      // }
  }, [searchTerm]);

  // Effect to log the debounced search term
  useEffect(() => {
    // if(searchTerm != '')
      ssr({page, limit:sizePerPage, search: searchTerm})
  }, [debouncedSearchTerm]);

  const sizePerPageList = [
    { text: '10', value: 10 },
    { text: '25', value: 25 },
    { text: '50', value: 50 },
    { text: '100', value: 100 },
    { text: 'All', value: rowsLength }
  ];

  const pageOptions = {
    sizePerPage: sizePerPage,
    totalSize: rowsLength,
    page: page || 1,
    hideSizePerPage: false,
    sizePerPageList: sizePerPageList,
  }

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    ssr({page, limit:sizePerPage, search: searchTerm})
  };

  return (
    <React.Fragment>
      <Row className="pb-6">
        <Col className="col-12">
          <Card>
            <CardBody>
              {
                loading ?
                <div style={{height: '160px'}}>
                  <div id="status" style={{height: '100vh', width: 'auto'}}>
                    <div className="spinner-chase">
                        <div className="chase-dot"></div>
                        <div className="chase-dot"></div>
                        <div className="chase-dot"></div>
                        <div className="chase-dot"></div>
                        <div className="chase-dot"></div>
                        <div className="chase-dot"></div>
                    </div>
                    <div style={{margin: '30px auto', textAlign: 'center'}}>Loading Please Wait...</div>
                  </div>  
                </div> :
                <ToolkitProvider
                  keyField={keyField}
                  data={rows}
                  columns={columns}
                  search
                  exportCSV={{
                    fileName: `${filename || 'msi_report'}_${new Date().toISOString().split('T')[0]}.csv`,
                    separator: ',',
                    noAutoBOM: false
                  }}
                >
                  {props => (
                    <>
                      {
                        isTableHead ?
                        <Row>
                          <Col sm="5">
                            <CardTitle className="d-flex h2" style={{ marginTop: "10px" }}>{title}</CardTitle>
                          </Col>

                          {selectField}
                          
                          <Col className="d-flex">
                          {
                            defaultDates ? 
                              <div className="me-4" style={{width: '320px'}}>
                                <Flatpickr
                                  value={defaultDates}
                                  className="form-control d-block"
                                  placeholder="DD-MM-YYYY"
                                  options={{
                                    mode: "range",
                                    dateFormat: "d-m-Y"
                                  }}
                                  onChange={
                                    (e) => {
                                        const dates = e.map(dateString => Timezone(dateString));
                                        daterange(dates)
                                    }
                                  }
                                />
                              </div>
                            : ''
                          }
                            {
                              isSearch ?
                                <div className="search-box me-2 d-inline-block" style={{ width: "82%" }}>
                                  <div className="position-relative">
                                    <input className="form-control" placeholder={placeholder} onChange={(e) => {
                                      setSearchTerm(e.target.value)
                                    }} defaultValue={searchTerm} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>: ''
                            }
                              <ExportCSVButton {...props.csvProps} className="btn btn-success me-2" style={{width: '160px'}}><i className="fas fa-file-csv me-2" /> Download </ExportCSVButton>
                            {
                              isAdd ?
                                <Button
                                  disabled={isDisabled}
                                  color="primary"
                                  style={{ float: "right", width: '160px' }}
                                  onClick={handleAddButton}
                                  onKeyDown={handleAddButton}
                                >
                                  <i className={`fas ${fas ? fas : "fa-plus" }`}>{" "}{btnTitle}</i>
                                </Button> : ''
                            }
                          </Col>
                        </Row> : ''
                      }
                      
                      <div className=" mt-4">
                        {loading ? (
                          <div className="text-center my-3">
                              <span className="">Loading...</span>
                            </div> 
                        ):
                        rows.length == 0 ? <div className="text-center">No data available</div> : (
                          <BootstrapTable
                            {...props.baseProps}
                            responsive
                            bordered={true}
                            striped={true}
                            classes="table align-middle table-nowrap"
                            headerWrapperClasses={"thead-light"}
                            remote={is_remote}
                            sort={defaultSorted}
                            pagination={paginationFactory(pageOptions)}
                            onTableChange={handleTableChange}
                          />
                        )
                      }
                      </div>
                    </>
                  )}
                </ToolkitProvider>
              }

            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Datatables
